import { Component, Inject, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-message-form.component',
  templateUrl: './message-form.component.html',
  styleUrls: [ './message-form.component.scss' ],
  providers: [ AngularFireDatabase, AngularFireAuth ]
})
export class MessageFormComponent implements OnInit {
  user: any;
  message : any = {};
  messagesRef: any;
  constructor (public afAuth: AngularFireAuth,
  public dialogRef : MatDialogRef<MessageFormComponent>,
  private db: AngularFireDatabase, @Inject(MAT_DIALOG_DATA) public data : any) {}

  ngOnInit() {
    this.messagesRef = this.db.list('messages/');
    this.afAuth.auth.onAuthStateChanged(user => {
    this.user =  user;
    });
  }

  sendMessage () {
    this.message.fromId = this.user.uid;
    this.message.name = this.user.displayName;
    this.message.createdAt = moment().format('YYYY-MM-dd HH:mm:ss');
    this.message.image = this.user.photoUrl? this.user.photoUrl : '';
    this.message.status = 'unread';
    this.message.toId = this.data.user.userId;

    if ( this.data.replyFrom ) this.message.replyFrom = this.data.replyFrom;

    this.messagesRef.push(this.message)
    .then(result => {
      this.message.id= result.key;
       let reference = this.db.object('messages/'+result.key);
       reference.update(this.message);
    });
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/users/message-form/message-form.component.ts